/**
 * Symbiosy environmental status palette (Sensor Mobile States design):
 * Excellent (2) and Acceptable (1) share the same green — the word carries
 * the difference; Moderate (0) is the neutral worst band; Unavailable is
 * grey with an em-dash value. Shared by the resource-detail environment
 * panel and the booking-card temperature vote.
 */
export const ENVIRONMENT_STATUS_COLORS = {
  good: '#0a6b4d',
  moderate: '#b07d00',
  unavailable: '#6a737c',
} as const;
